/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Ticketsdeletetitle2Inputs */

const en_ticketsdeletetitle2 = /** @type {(inputs: Ticketsdeletetitle2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Delete "${i?.name}"?`)
};

const de_ticketsdeletetitle2 = /** @type {(inputs: Ticketsdeletetitle2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`„${i?.name}“ löschen?`)
};

/**
* | output |
* | --- |
* | "Delete \"{name}\"?" |
*
* @param {Ticketsdeletetitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsdeletetitle2 = /** @type {((inputs: Ticketsdeletetitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsdeletetitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsdeletetitle2(inputs)
	return de_ticketsdeletetitle2(inputs)
});
export { ticketsdeletetitle2 as "ticketsDeleteTitle" }